import React from 'react'
import { Helmet } from 'react-helmet'
import ReactDatePicker from 'react-datepicker'
import MaskedInput from 'react-text-mask'
import { it } from 'date-fns/locale'
import { Input } from './Input'
import styled from 'styled-components'

type DateOrNull = Date | null

interface Props {
  value: DateOrNull
  onChange: (newDate: DateOrNull) => void
  withMaskedInput?: boolean
  placeholderText?: string
  minDate?: DateOrNull
  maxDate?: DateOrNull
  isClearable?: boolean
  invalid?: boolean
}

export const DatePicker: React.FC<Props> = ({
  value,
  onChange,
  placeholderText,
  minDate,
  maxDate,
  isClearable,
  invalid,
  ...rest
}) => {
  return (
    <DatePickerWrapper>
      <Helmet>
        <link
          rel='stylesheet'
          href='https://cdnjs.cloudflare.com/ajax/libs/react-datepicker/2.12.1/react-datepicker.min.css'
        />
      </Helmet>
      <ReactDatePicker
        locale={it}
        fixedHeight
        dateFormat={'dd/MM/yyyy'}
        isClearable={isClearable}
        selected={value}
        onChange={onChange}
        placeholderText={placeholderText}
        minDate={minDate}
        maxDate={maxDate}
        customInput={
          <MaskedInput
            {...rest}
            type='text'
            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
            render={(ref, props) => {
              return (
                <Input ref={ref} invalid={invalid} isInDatePicker {...props} />
              )
            }}
          />
        }
      />
    </DatePickerWrapper>
  )
}

const DatePickerWrapper = styled.div`
  //Override Datepicker Library Style

  .react-datepicker-wrapper {
    display: block;
  }

  .react-datepicker__input-container {
    //Nothing to override
  }
`
